import axios from 'axios';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // withCredentials: true,
});

// Remove Content-Type header for FormData requests so axios can set multipart boundary
http.interceptors.request.use((config) => {
  const isFormData = config.data instanceof FormData ||
    (config.data && config.data.constructor && config.data.constructor.name === 'FormData');

  if (isFormData) {
    // Handle both old and new axios header formats
    if (config.headers && typeof config.headers.delete === 'function') {
      config.headers.delete('Content-Type');
    } else if (config.headers) {
      delete (config.headers as Record<string, any>)['Content-Type'];
    }
    // Ensure axios doesn't transform the data
    config.transformRequest = [(data: any) => data];
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Status 401 received, logging out!!!!');
      localStorage.removeItem('orgInfo');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('accessToken');
      // sessionStorage.removeItem('onboarding');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default http;
